import { MODEL_PROVIDER_LABEL, type TModelPrice, type TModelProvider } from 'shared-types';

type TGroupedOption = { group: string; items: { value: string; label: string }[] };

const PROVIDER_ORDER: TModelProvider[] = ['openai', 'google', 'anthropic', 'deepseek'];

const formatPrice = (raw: string): string => {
  const n = parseFloat(raw);
  if (!isFinite(n)) return raw;
  return `$${n.toFixed(2)}`;
};

const shortName = (id: string): string => id.split('/')[1] ?? id;

const buildLabel = (m: TModelPrice): string =>
  `${shortName(m.model)} · ${formatPrice(m.prompt_price_per_1m)} / ${formatPrice(m.completion_price_per_1m)} за 1M`;

// Mantine Select v8 принимает массив групп { group, items: [{value, label}] }.
// Группируем по provider, сохраняя порядок PROVIDER_ORDER, внутри группы — порядок из API.
export const buildModelSelectGroups = (models: TModelPrice[]): TGroupedOption[] => {
  const buckets = new Map<TModelProvider, TModelPrice[]>();
  for (const m of models) {
    const list = buckets.get(m.provider) ?? [];
    list.push(m);
    buckets.set(m.provider, list);
  }
  return PROVIDER_ORDER.filter((p) => buckets.has(p)).map((p) => ({
    group: MODEL_PROVIDER_LABEL[p],
    items: (buckets.get(p) ?? []).map((m) => ({ value: m.model, label: buildLabel(m) }))
  }));
};
